import { ReactNode } from 'react';

import { NotificationName } from 'utils/constants/notification';

import { NotificationKind } from 'bloko/blocks/notificationManager/Notification';

import CopySuccess from 'components/Notifications/components/CopySuccess';

type NotificationConfig = {
    [key in NotificationName]: {
        kind?: NotificationKind;
        trl?: string;
        title?: string;
        customComponent?: ReactNode;
        dataQa?: string;
    };
};

const NOTIFICATION_CONFIG: NotificationConfig = {
    [NotificationName.SomethingWentWrong]: {
        kind: NotificationKind.Error,
        title: 'somethingWentWrong.notification.title',
        trl: 'somethingWentWrong.notification.text',
    },
    [NotificationName.CheckBannerModeration]: {
        kind: NotificationKind.Ok,
        trl: 'manager.notification.ok',
    },
    [NotificationName.SendRefund]: {
        kind: NotificationKind.Ok,
        trl: 'manager.notification.ok',
    },
    [NotificationName.SendBonus]: {
        kind: NotificationKind.Ok,
        trl: 'manager.notification.ok',
    },
    [NotificationName.InvoicesPageError]: {
        kind: NotificationKind.Error,
        trl: 'manager.notification.error',
    },
    [NotificationName.CampaignFormImageSuccess]: {
        kind: NotificationKind.Ok,
        trl: 'AdCreate.AdForm.BannerImg.notification.ok',
        dataQa: 'notification-image-loaded',
    },
    [NotificationName.CampaignFormImageReady]: {
        kind: NotificationKind.Ok,
        trl: 'AdCreate.AdForm.BannerImg.notification.ready',
    },
    [NotificationName.CampaignFormImageCancel]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.cancel',
    },
    [NotificationName.CampaignFormImageTooHighResolution]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.highResolution',
    },
    [NotificationName.CampaignFormImageTooLowResolution]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.lowResolution',
    },
    [NotificationName.CampaignFormImageTooLowResolutionForSources]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.lowResolutionForSources',
    },
    [NotificationName.CampaignFormImageTooBigSize]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.bitSize',
    },
    [NotificationName.CampaignFormImageWrongExtension]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.wrongExtension',
    },
    [NotificationName.CampaignFormImageSomethingWentWrong]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.somethingWentWrong',
    },
    [NotificationName.CampaignFormCropImageSomethingWentWrong]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.CropImg.notification.somethingWentWrong',
    },
    [NotificationName.CampaignFormImageUnableToCropImage]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.lowResolutionForSources',
    },
    [NotificationName.CampaignFormDefaultImagesError]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerImg.DefaultImages.notification.somethingWentWrong',
    },
    [NotificationName.CampaignsSearchSomethingWentWrong]: {
        kind: NotificationKind.Error,
        title: 'Dashboard.CampaignsSearch.notification.somethingWentWrong.title',
        trl: 'Dashboard.CampaignsSearch.notification.somethingWentWrong.text',
    },
    [NotificationName.DashboardFiltersSomethingWentWrong]: {
        kind: NotificationKind.Error,
        title: 'Dashboard.Filters.notification.somethingWentWrong.title',
        trl: 'Dashboard.Filters.notification.somethingWentWrong.text',
    },
    [NotificationName.DashboardLoadFiltersSomethingWentWrong]: {
        kind: NotificationKind.Error,
        trl: 'Dashboard.Filters.FiltersDropContent.notification.somethingWentWrong.text',
    },
    [NotificationName.InvoicesPageErrorMaxPeriod]: {
        kind: NotificationKind.Error,
        trl: 'admin.Invoices.Filter.notification.maxPeriod',
    },
    [NotificationName.DashboardCampaignListSomethingWentWrong]: {
        kind: NotificationKind.Error,
        trl: 'dashboard.CampaignList.notification.somethingWentWrong',
    },
    [NotificationName.UsersPageErrorSomethingWentWrong]: {
        kind: NotificationKind.Error,
        trl: 'admin.Users.notification.somethingWentWrong',
    },
    [NotificationName.CrmUpdateSuccess]: {
        kind: NotificationKind.Ok,
        trl: 'Admin.CrmActivity.notification.ok',
    },
    [NotificationName.CrmUpdateAlert]: {
        kind: NotificationKind.Error,
        trl: 'Admin.CrmActivity.notification.needAtLeastOneOwner',
    },
    [NotificationName.CrmUpdateError]: {
        kind: NotificationKind.Error,
        trl: 'Admin.CrmActivity.notification.error',
    },
    [NotificationName.ImageUpscaleSomethingWentWrong]: {
        kind: NotificationKind.Error,
        trl: 'BannerImg.CropImageModal.ImageContent.upscaleError.upscale',
    },
    [NotificationName.ImageUpscaleInfoSomethingWentWrong]: {
        kind: NotificationKind.Error,
        trl: 'BannerImg.CropImageModal.ImageContent.upscaleError.info',
    },
    [NotificationName.PayersPageErrorEmptyValue]: {
        kind: NotificationKind.Error,
        trl: 'admin.Payers.Filter.notification.emptyValue',
    },
    [NotificationName.PayersPageUpdatePayerDataSuccess]: {
        kind: NotificationKind.Ok,
        trl: 'admin.PayerDetail.Edit.save.success',
    },
    [NotificationName.PayersPageUpdatePayerDataError]: {
        kind: NotificationKind.Error,
        trl: 'admin.PayerDetail.Edit.save.error',
    },
    [NotificationName.CampaignFormFieldsError]: {
        trl: 'AdCreate.AdForm.Fields.error',
    },
    [NotificationName.TranslationsSaveSuccess]: {
        kind: NotificationKind.Ok,
        trl: 'admin.Translation.Edit.save.success',
    },
    [NotificationName.AccountStatisticsNotAccountId]: {
        kind: NotificationKind.Error,
        trl: 'admin.accountStatisticsReport.notAccountId.error',
    },
    [NotificationName.AccountCreateSuccess]: {
        kind: NotificationKind.Ok,
        trl: 'account.create.notification',
    },
    [NotificationName.AccountEditSuccess]: {
        kind: NotificationKind.Ok,
        trl: 'account.edit.notification',
    },
    [NotificationName.CampaignsReportError]: {
        kind: NotificationKind.Error,
        trl: 'admin.campaignsReport.error',
    },
    [NotificationName.UseBannerLinkForVacancy]: {
        title: 'useBannerLinkForVacancy.notification.title',
        trl: 'useBannerLinkForVacancy.notification.text',
    },
    [NotificationName.ErrorAccessInBannerLink]: {
        kind: NotificationKind.Error,
        title: 'errorAccessInBannerLink.notification.title',
        trl: 'errorAccessInBannerLink.notification.text',
    },
    [NotificationName.ErrorVacancyInBannerLink]: {
        kind: NotificationKind.Error,
        title: 'errorVacancyInBannerLink.notification.title',
        trl: 'errorVacancyInBannerLink.notification.text',
    },
    [NotificationName.ErrorUrlInBannerLink]: {
        kind: NotificationKind.Error,
        title: 'errorUrlInBannerLink.notification.title',
        trl: 'CampaignCreationWizard.VacancySelectStep.website.errorInvalidUrl',
    },
    [NotificationName.CreateCampaignSomethingWentWrongError]: {
        kind: NotificationKind.Error,
        trl: 'create.campaign.somethingWentWrong.error',
    },
    [NotificationName.CreateBannerSomethingWentWrongError]: {
        kind: NotificationKind.Error,
        trl: 'create.banner.somethingWentWrong.error',
    },
    [NotificationName.AuctionFormValidationError]: {
        kind: NotificationKind.Error,
        trl: 'auctionForm.validation.error',
    },
    [NotificationName.AuctionFormLowBalanceError]: {
        kind: NotificationKind.Error,
        title: 'auctionForm.lowBalance.error.title',
        trl: 'auctionForm.lowBalance.error',
    },
    [NotificationName.AuctionFormSomethingWentWrongError]: {
        kind: NotificationKind.Error,
        trl: 'auctionForm.somethingWentWrong.error',
    },
    [NotificationName.AuctionFormDuplicatedCampaignError]: {
        kind: NotificationKind.Error,
        trl: 'auctionForm.duplicatedCampaign.error',
    },
    [NotificationName.CampaignCopySuccess]: {
        title: 'campaign.copy.success',
        customComponent: <CopySuccess />,
    },
    [NotificationName.CampaignsReportMaxDateError]: {
        title: 'admin.campaignsReport.calendar.dateOutOfRange',
        kind: NotificationKind.Error,
    },
    [NotificationName.EditingActDataError]: {
        kind: NotificationKind.Error,
        trl: 'admin.actsReport.editingAct.data.error',
    },
    [NotificationName.DuplicateActError]: {
        kind: NotificationKind.Error,
        trl: 'admin.actsReport.duplicateAct.error',
    },
    [NotificationName.EditingActForbiddenError]: {
        kind: NotificationKind.Error,
        trl: 'admin.actsReport.editingAct.forbidden.error',
    },
    [NotificationName.EditingActNotFoundError]: {
        kind: NotificationKind.Error,
        trl: 'admin.actsReport.editingAct.notFound.error',
    },
    [NotificationName.CampaignChangeStatusToArchiveSuccess]: {
        kind: NotificationKind.Ok,
        trl: 'dashboard.campaign.actions.updateCampaignStatus.archive',
    },
    [NotificationName.CampaignChangeStatusToActiveSuccess]: {
        kind: NotificationKind.Ok,
        trl: 'dashboard.campaign.actions.updateCampaignStatus.active',
    },
    [NotificationName.CampaignMultiChangeStatusToBlockedSuccess]: {
        kind: NotificationKind.Ok,
        trl: 'dashboard.campaign.actions.multiUpdateCampaignStatus.blocked.success',
    },
    [NotificationName.CampaignMultiChangeStatusToBlockedError]: {
        kind: NotificationKind.Error,
        trl: 'dashboard.campaign.actions.multiUpdateCampaignStatus.blocked.error',
    },
    [NotificationName.CampaignFormVideoTooBigSize]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.bitSize',
    },
    [NotificationName.CampaignFormVideoTooLongDuration]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.bitDuration',
    },
    [NotificationName.CampaignFormVideoTooShortDuration]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.lowDuration',
    },
    [NotificationName.CampaignFormVideoWrongResolution]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.wrongResolution',
    },
    [NotificationName.CampaignFormVideoSomethingWentWrong]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.somethingWentWrong',
    },
    [NotificationName.CampaignFormVideoWrongFormat]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.wrongFormat',
    },
    [NotificationName.CampaignFormVideoErrorWhileProcess]: {
        kind: NotificationKind.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.errorWhileProcess',
    },
    [NotificationName.BannerLinkCopyToClipboardSuccess]: {
        kind: NotificationKind.Ok,
        trl: 'dashboard.banner.preview.copyToClipboard.success',
    },
    [NotificationName.CampaignArchiveError]: {
        kind: NotificationKind.Error,
        trl: 'campaign.info.sudo.actions.archiveCampaign.error',
    },
};

export default NOTIFICATION_CONFIG;
